module.exports = __webpack_public_path__ + "static/media/ysly.ff4754b0.png";